// extracted by mini-css-extract-plugin
module.exports = {"connectWalletButton":"ConnectWalletButton_connectWalletButton__1TW63"};